import { FC } from 'react';

import { IPopover, PopoverMenu } from '@gem/ui-kit';

import type { ChatMessage } from 'STORE/Messages/Message/ChatMessage/ChatMessage';

import { useSenderPopoverMenuForAdminPresenter } from './SenderPopoverMenuForAdmin.presenter';

interface ISenderPopoverMenuProps {
  message: ChatMessage;
  senderId: string;
  popover: IPopover;
}

export const SenderPopoverMenuForAdmin: FC<ISenderPopoverMenuProps> = (props) => {
  const { message, senderId, popover } = props;

  const presenter = useSenderPopoverMenuForAdminPresenter({ message, senderId });

  return (
    <PopoverMenu
      isOpened={popover.isOpened}
      menuItems={presenter.menuItems}
      onClose={popover.close}
      reference={popover.containerRef.current}
      placement="top-start"
    />
  );
};
